export function saveSchedule(event, saveEventOnDb) {
    if (event.eventRecord) {
        return saveEventOnDb(event.eventRecord, event.source);
    }
} 